import { Controller } from "@hotwired/stimulus";

// Copie le contenu textuel d'un élément (snippet, enregistrement DNS, balise
// meta) dans le presse-papier, avec retour visuel « Copié » temporaire.
//
//   <div data-controller="marketing-copy">
//     <code id="snippet-code">...</code>
//     <button data-action="marketing-copy#copy" data-copy-target="snippet-code">Copier</button>
//   </div>
export default class extends Controller {
  copy(event) {
    const button = event.currentTarget;
    const targetId = button.dataset.copyTarget;
    const source = targetId ? document.getElementById(targetId) : this.element;
    if (!source) return;

    const text = source.innerText || source.textContent || "";
    const done = () => {
      const original = button.innerHTML;
      button.innerHTML = '<i class="fa-solid fa-check"></i> Copié';
      button.classList.add("is-copied");
      setTimeout(() => {
        button.innerHTML = original;
        button.classList.remove("is-copied");
      }, 1500);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done).catch(() => this.fallback(text, done));
    } else {
      this.fallback(text, done);
    }
  }

  fallback(text, done) {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand("copy"); done(); } catch (_) { /* noop */ }
    document.body.removeChild(ta);
  }
}
